import { fetchBasicJsonPost, fetchBasicJsonPostJson, fetchBasicUrlGetJson, fetchBasicUrlPost } from '../script/common';

export default {
    constant: {
        parentCode: (function () {
            var _locals = {
                pharmacy: null,
                branch: null,
                insurance: null
            };
            return {
                async pharmacy() {
                    if (_locals.pharmacy === null) {
                        await fetchBasicJsonPostJson(
                            '/Organization/GetPharmacyParentCode'
                        ).then(resp => (_locals.pharmacy = resp));
                    }
                    return _locals.pharmacy;
                },
                async branch() {
                    if (_locals.branch === null) {
                        await fetchBasicJsonPostJson(
                            '/Organization/GetBranchParentCode'
                        ).then(resp => (_locals.branch = resp));
                    }
                    return _locals.branch;
                },
                async insurance() {
                    if (_locals.insurance === null) {
                        await fetchBasicJsonPostJson(
                            '/Organization/GetInsuranceParentCode'
                        ).then(resp => (_locals.insurance = resp));
                    }
                    return _locals.insurance;
                }
            };
        })()
    },
    getData: (page, itemsPerPage, filter, signal) => {
        var parameters = {
            page: page,
            pageSize: itemsPerPage
        };
        if (filter) {
            parameters.code = filter.code || null;
            parameters.search = filter.search || null;
            parameters.has_payment_in_advance = filter.has_payment_in_advance;
            if (
                !parameters.code &&
                parameters.search &&
                /^\d+$/.test(parameters.search)
            ) {
                parameters.code = +parameters.search;
                parameters.search = null;
            }
            parameters.kod = filter.kod || null;
            parameters.parent_code =
                filter.parent_code && /^\d+$/.test(filter.parent_code)
                    ? +filter.parent_code
                    : parameters.code || parameters.search ? null : 0;
        }
        return fetchBasicJsonPostJson(
            '/Organization/GetDataTableData',
            {
                data: parameters,
                signal: signal
            },
            {
                useBlock: !signal
            }
        );
    },
    add: item => {
        return fetchBasicJsonPost('/Organization/Add', {
            data: item
        });
    },
    edit: item => {
        if (!item.parent_code) {
            item.parent_code = 0;
        }
        if (!item.region) {
            item.region = 0;
        }
        return fetchBasicJsonPost('/Organization/Edit', {
            data: item
        });
    },
    getPaymentInAdvance: (code, date) =>
        fetchBasicUrlGetJson(
            '/Organization/GetPaymentInAdvance',
            { data: { code, date } }
        ),
    addPaymentInAdvance: (code, amount, paymentType, date, comment) =>
        fetchBasicUrlPost(
            '/Organization/AddPaymentInAdvance',
            { data: { code, amount, paymentType, date, comment } }
        ),
    autoPayment: (year, month, organizationCode) =>
        fetchBasicJsonPost(
            '/Payment/AutoPayFromOrganization',
            { data: { year, month, organizationId: organizationCode } }
        ),
    clearAutoPayment: (year, month, organizationCode) =>
        fetchBasicJsonPost(
            '/Payment/ClearAutoPayFromOrganization',
            { data: { year, month, organizationId: organizationCode } }
        )
};
